module.exports = __webpack_public_path__ + "static/soutard-ddf3bb8ce985472dbec144ead6af8af4.png";